import { shellSlots, type SlotContribution } from '@/shared/registry'

/** A Super User's site picker in the nav bar, and the banner naming the site acted on above it (110552). */
export const actingSiteSlots: readonly SlotContribution[] = [
  {
    kind: 'action',
    slot: shellSlots.headerActions,
    id: 'site-picker',
    component: () => import('./SitePicker').then((module) => module.SitePicker),
  },
  {
    kind: 'panel',
    slot: shellSlots.headerBanners,
    id: 'acting-site',
    component: () => import('./ActingSiteBanner').then((module) => module.ActingSiteBanner),
  },
]
